/**
 * Couleur d'identification de chaque canal de vente.
 * Volontairement distinctes du vert / noir qui servent déjà à l'alternance
 * des produits, pour que le canal reste lisible d'un coup d'oeil.
 */
const channelColors = {
  spot: "brown",
  shop_v2: "orange",
  deliveroo: "deliveroo"
};

export const channelColor = (theme, type) =>
  theme.colors[channelColors[type]] || theme.colors.grey;

export default channelColor;
